import { ONBOARDING_RAIL, STEP_SECONDS } from '@forwardflow/constants/onboarding.constants'
import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { TOnboardingStep } from '@forwardflow/types/onboarding'

/** "about 2 min left" from the customer-time budget of the steps ahead. */
const timeLeftLabel = (steps: TOnboardingStep[], fromStep: TOnboardingStep) => {
   const index = steps.indexOf(fromStep)
   const seconds = steps
      .slice(Math.max(0, index))
      .reduce((sum, step) => sum + (STEP_SECONDS[step] ?? 30), 0)
   if (seconds <= 0) return null
   if (seconds < 60) return 'under a minute left'
   const minutes = Math.max(1, Math.round(seconds / 60))
   return `about ${minutes} min left`
}

/**
 * The one-line position: "Step 3 of 7 · about 2 min left". The full picture
 * lives in the rail (`SetupRail`); this is the header's summary of it.
 */
export const Stepper = () => {
   const { onboardingData } = useOnboardingStoreV2()
   const currentStep = onboardingData.currentStep
   const allSteps = ONBOARDING_RAIL.flatMap((r) => r.steps)
   const railIndex = ONBOARDING_RAIL.findIndex((r) => r.steps.includes(currentStep))
   if (railIndex < 0) return null
   const timeLeft = timeLeftLabel(allSteps, currentStep)
   return (
      <p className="text-white/50 text-xs leading-tight" data-testid="stepper-position">
         Step {railIndex + 1} of {ONBOARDING_RAIL.length}
         {timeLeft ? ` · ${timeLeft}` : ''}
      </p>
   )
}
